// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================
   ScoreEditor Modal
================================ */
:root {
  --score-bg-overlay: rgba(15, 23, 42, 0.45);
  --score-card-bg: #ffffff;
  --score-border-subtle: rgba(148, 163, 184, 0.35);
  --score-shadow: 0 22px 55px rgba(15, 23, 42, 0.42);
  --accent-600: #4f46e5;
}

/* Backdrop */
.score-backdrop {
  position: fixed;
  inset: 0;
  background: var(--score-bg-overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Modal */
.score-modal {
  width: 640px;
  max-width: 96%;
  background: radial-gradient(circle at top left, #eef2ff, #ffffff);
  border-radius: 18px;
  border: 1px solid var(--score-border-subtle);
  box-shadow: var(--score-shadow);
  padding: 18px 18px 16px;
}

/* Header */
.score-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 12px;
}

.score-header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--text-main, #0f172a);
}

.score-subtitle {
  margin: 4px 0 0;
  font-size: 0.85rem;
  color: var(--text-muted, #6b7280);
}

.score-close-btn {
  padding-inline: 0.6rem;
}

/* Score cards row */
.score-row {
  display: flex;
  gap: 12px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.score-card {
  flex: 1 1;
  min-width: 130px;
  border-radius: 12px;
  padding: 10px 12px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  background: linear-gradient(135deg, #f9fafb, #eef2ff);
}

.score-card--current {
  background: linear-gradient(135deg, #fefce8, #fef9c3);
  border-color: rgba(250, 204, 21, 0.5);
}

.score-card--new {
  background: linear-gradient(135deg, #e0f2fe, #e0f7ff);
  border-color: rgba(59, 130, 246, 0.55);
}

.score-card-label {
  font-size: 0.8rem;
  color: #6b7280;
}

.score-card-value {
  margin-top: 6px;
  font-size: 1.6rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  color: #111827;
}

/* Inputs grid */
.score-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
  margin-bottom: 14px;
}

@media (max-width: 640px) {
  .score-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* Input group */
.score-input-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.score-input-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #374151;
}

.score-input {
  width: 100%;
  padding: 7px 10px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  font-size: 0.9rem;
  text-align: left;
  outline: none;
  background: #ffffff;
  transition: border 0.14s ease, box-shadow 0.14s ease, transform 0.1s ease;
}

.score-input:focus {
  border-color: var(--accent-600, #4f46e5);
  box-shadow: 0 0 0 1px rgba(129, 140, 248, 0.6),
    0 16px 32px rgba(79, 70, 229, 0.18);
  transform: translateY(-1px);
}

.score-input-hint {
  font-size: 0.75rem;
  color: #9ca3af;
}

/* Footer */
.score-footer {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(226, 232, 240, 0.9);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.score-footer-left {
  display: flex;
  gap: 0.5rem;
}

.score-footer-right {
  display: flex;
  gap: 0.4rem;
}

/* ==========================
   Save Button (primary CTA)
========================== */
.score-save-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.6rem 1.4rem;
  min-width: 130px;
  border-radius: 0.6rem;
  border: none;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  background: var(--accent-600);
  color: #ffffff;
  /* box-shadow: 0 14px 32px rgba(79, 70, 229, 0.75); */
  transition: transform 0.12s ease, box-shadow 0.12s ease, filter 0.12s ease;
}

.score-save-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  /* box-shadow: 0 18px 40px rgba(79, 70, 229, 0.9); */
  filter: brightness(1.03);
}

.score-save-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  /* box-shadow: 0 8px 20px rgba(148, 163, 184, 0.7); */
}
`, "",{"version":3,"sources":["webpack://./src/styles/ScoreEditor.css"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;EACE,0CAA0C;EAC1C,wBAAwB;EACxB,gDAAgD;EAChD,kDAAkD;EAClD,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,QAAQ;EACR,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,UAAU;AACV;EACE,YAAY;EACZ,cAAc;EACd,iEAAiE;EACjE,mBAAmB;EACnB,4CAA4C;EAC5C,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;EACrD,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yEAAyE;AAC3E;;AAEA;EACE,wCAAwC;EACxC;uCACqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;4BAE4B;AAC5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,qDAAqD;EACrD,0EAA0E;AAC5E;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;EACpD,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;AACvD","sourcesContent":["/* ================================\n   ScoreEditor Modal\n================================ */\n:root {\n  --score-bg-overlay: rgba(15, 23, 42, 0.45);\n  --score-card-bg: #ffffff;\n  --score-border-subtle: rgba(148, 163, 184, 0.35);\n  --score-shadow: 0 22px 55px rgba(15, 23, 42, 0.42);\n  --accent-600: #4f46e5;\n}\n\n/* Backdrop */\n.score-backdrop {\n  position: fixed;\n  inset: 0;\n  background: var(--score-bg-overlay);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n/* Modal */\n.score-modal {\n  width: 640px;\n  max-width: 96%;\n  background: radial-gradient(circle at top left, #eef2ff, #ffffff);\n  border-radius: 18px;\n  border: 1px solid var(--score-border-subtle);\n  box-shadow: var(--score-shadow);\n  padding: 18px 18px 16px;\n}\n\n/* Header */\n.score-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 12px;\n}\n\n.score-header h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: var(--text-main, #0f172a);\n}\n\n.score-subtitle {\n  margin: 4px 0 0;\n  font-size: 0.85rem;\n  color: var(--text-muted, #6b7280);\n}\n\n.score-close-btn {\n  padding-inline: 0.6rem;\n}\n\n/* Score cards row */\n.score-row {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 14px;\n  flex-wrap: wrap;\n}\n\n.score-card {\n  flex: 1;\n  min-width: 130px;\n  border-radius: 12px;\n  padding: 10px 12px;\n  border: 1px solid rgba(148, 163, 184, 0.45);\n  background: linear-gradient(135deg, #f9fafb, #eef2ff);\n}\n\n.score-card--current {\n  background: linear-gradient(135deg, #fefce8, #fef9c3);\n  border-color: rgba(250, 204, 21, 0.5);\n}\n\n.score-card--new {\n  background: linear-gradient(135deg, #e0f2fe, #e0f7ff);\n  border-color: rgba(59, 130, 246, 0.55);\n}\n\n.score-card-label {\n  font-size: 0.8rem;\n  color: #6b7280;\n}\n\n.score-card-value {\n  margin-top: 6px;\n  font-size: 1.6rem;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  color: #111827;\n}\n\n/* Inputs grid */\n.score-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px 12px;\n  margin-bottom: 14px;\n}\n\n@media (max-width: 640px) {\n  .score-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n/* Input group */\n.score-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.score-input-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.score-input {\n  width: 100%;\n  padding: 7px 10px;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  font-size: 0.9rem;\n  text-align: left;\n  outline: none;\n  background: #ffffff;\n  transition: border 0.14s ease, box-shadow 0.14s ease, transform 0.1s ease;\n}\n\n.score-input:focus {\n  border-color: var(--accent-600, #4f46e5);\n  box-shadow: 0 0 0 1px rgba(129, 140, 248, 0.6),\n    0 16px 32px rgba(79, 70, 229, 0.18);\n  transform: translateY(-1px);\n}\n\n.score-input-hint {\n  font-size: 0.75rem;\n  color: #9ca3af;\n}\n\n/* Footer */\n.score-footer {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(226, 232, 240, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.score-footer-left {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.score-footer-right {\n  display: flex;\n  gap: 0.4rem;\n}\n\n/* ==========================\n   Save Button (primary CTA)\n========================== */\n.score-save-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.6rem 1.4rem;\n  min-width: 130px;\n  border-radius: 0.6rem;\n  border: none;\n  font-size: 0.9rem;\n  font-weight: 700;\n  cursor: pointer;\n  background: var(--accent-600);\n  color: #ffffff;\n  /* box-shadow: 0 14px 32px rgba(79, 70, 229, 0.75); */\n  transition: transform 0.12s ease, box-shadow 0.12s ease, filter 0.12s ease;\n}\n\n.score-save-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  /* box-shadow: 0 18px 40px rgba(79, 70, 229, 0.9); */\n  filter: brightness(1.03);\n}\n\n.score-save-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  /* box-shadow: 0 8px 20px rgba(148, 163, 184, 0.7); */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
